<div class="confirm-overlay" >
  <div class="confirm-sheet" (click)="$event.stopPropagation()">

    <div class="confirm-close-row">
      <button class="confirm-close" type="button" (click)="close()">
        X
      </button>
    </div>

    <div class="confirm-body">
      <div class="help-dialog-frame-wrapper">
        <div class="help-dialog-registration-help-parent">
          <div class="help-dialog-registration-help">{{ title|translate }}</div>
          <div class="help-dialog-having-difficulty-with-container">
            <p><br/>{{ subHeading|translate }}</p>
            <ul class="doubleSpacedList py-2">
              @for (text of helpItems; track $index) {
                <li class="py-2">{{ text|translate }}</li>
              }
            </ul>
            <p>{{ footer|translate }}{{supportMail}}</p>
          </div>
        </div>
      </div>
    </div>

    <div class="help-dialog-button-wrapper">
      <div class="help-dialog-button" (click)="close()">
        <div class="help-dialog-button-container">
          <div class="help-dialog-button2">Close</div>
        </div>
      </div>
    </div>
  </div>
</div>
